import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { workspacePortalLabel, type WorkspaceKind } from '@/lib/workspaces';

/** Shown above a portal while IDSeat views it without a membership; the way back to the internal admin. */
export function ViewAsBanner() {
  const { viewingAs, closeViewAs } = useAuth();
  const navigate = useNavigate();
  if (!viewingAs) return null;
  return (
    <div role="status" className="flex items-center justify-between gap-3 bg-accent/10 border-b border-accent/30 px-4 lg:px-[26px] py-2 text-sm">
      <span>
        Viewing <strong>{viewingAs.name}</strong> ({workspacePortalLabel(viewingAs.kind as WorkspaceKind)}) as IDSeat
      </span>
      <Button size="sm" variant="outline" className="rounded-[9px]" onClick={() => { closeViewAs(); navigate('/admin'); }}>
        Back to admin
      </Button>
    </div>
  );
}
